import { phpRequest } from "./phpRequest";

export const removeSubscriptionAPI = (valueAddedServiceId, t) => {
  return phpRequest.post("/subscribe/delete", {
    subscribe_value_added_service_id: valueAddedServiceId,
  });
};
